import React from 'react';
import {Datagrid, Filter, List, SelectInput, TextField, TextInput} from 'react-admin';
import {schoolYears} from "../../components";

const AccessDeviceFilter = (props) => (
    <Filter {...props}>
        <TextInput label="ra.action.search" source="q" alwaysOn/>
        <SelectInput label="resources.schoolYears.name" source="schoolYear" choices={schoolYears}
                     alwaysOn allowEmpty={false}
        />
    </Filter>
);

export const AdmissionSttConfigList = props => (
    <List filters={<AccessDeviceFilter/>}
          filterDefaultValues={{schoolYear : schoolYears != null && schoolYears.length > 0 ? schoolYears[0].id : null}} {...props}
          exporter={false}>
        <Datagrid rowClick="edit">
            <TextField source="name"/>
            <TextField source="timeDesc"/>
            <TextField source="startStt"/>
            <TextField source="endStt"/>
        </Datagrid>
    </List>
);

export default AdmissionSttConfigList
